import React, { useEffect, useState } from "react";
import LifeLongLearningItems from "./LifeLongLearningItems";
import { makeGetRequest } from "../../../utils/api";
import { urls } from "../../../utils/urls";
import NoResourceMessage from "../resources/NoResourceMessage";

function LifeLongLearningList(props) {
  const [dataPulled, setDataPulled] = useState(false);
  const handleLifeLongLearningData = async () => {
    const response = await makeGetRequest(
      urls.resources + "?active=True",
      "",
      true
    );
    const lifeLongLearningData = response.data.filter((item) => {
      return item.type === 0;
    });
    setLifeLongLearningItemsList(lifeLongLearningData);
    setDataPulled(true)
  };

  useEffect(() => {
    handleLifeLongLearningData();
  }, []);

  const [lifeLongLearningItemsList, setLifeLongLearningItemsList] = useState([]);

  return (
    <>
      {dataPulled && lifeLongLearningItemsList.length === 0 ? (
        <NoResourceMessage resource={"life long learning"} />
      ) : null}
      <LifeLongLearningItems
        lifeLongLearningItemsList={lifeLongLearningItemsList}
        setFile={props.setFile}
        setXframe={props.setXframe}
      />
    </>
  );
}

export default LifeLongLearningList;
